<div class='wrapper wrapper-content animated fadeIn'>
    <div class='row'>
        <div class='col-lg-12'>
            <div class='text-center m-t-lg'>
                <h1>{{'oStarter.sTitle'|translate}}</h1>
            </div>
        </div>
    </div>
</div>
